import { createContext, useContext, useRef } from "react";

import { hasUsableStoredSession } from "../../services/auth/tokenService";
import { AUTH_SESSION_STATUS, AuthSessionContext } from "./authSessionContext";

// Without a provider the chrome shows, which is how the app behaved before.
const AppChromeContext = createContext(true);

// The app chrome (TopNav, Footer, BackToMission, the nav Dynamic Page) fetches
// as soon as it mounts. On a boot with no session it mounted anyway and every
// one of those requests came back 401 while the app was already on its way to
// sign-in, so it now waits for a session that can exist.
//
// Sticky once shown: a session that ends (logout, expiry) keeps the chrome on
// screen until the provider redirect replaces the page, exactly as before.
export function AppChromeProvider({ children }) {
  const { status } = useContext(AuthSessionContext);
  const shownRef = useRef(false);

  const visible =
    shownRef.current ||
    status === AUTH_SESSION_STATUS.AUTHENTICATED ||
    (status === AUTH_SESSION_STATUS.LOADING && hasUsableStoredSession());
  shownRef.current = visible;

  return (
    <AppChromeContext.Provider value={visible}>
      {children}
    </AppChromeContext.Provider>
  );
}

export const useAppChromeVisible = () => useContext(AppChromeContext);

export function AppChromeOnly({ children }) {
  return useAppChromeVisible() ? children : null;
}
